import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import { nimmSessionEnde } from '../lib/pocketbase.js';
import logo from '../assets/logo.png';

export default function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [hinweis, setHinweis] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Wurde die Session im Hintergrund beendet (gesperrt, Token ungültig),
  // hinterlegt der AuthContext den Grund — sonst stünde der User ohne
  // Erklärung wieder auf dem Login.
  useEffect(() => {
    setHinweis(nimmSessionEnde());
  }, []);

  if (isAuthenticated) {
    navigate(from, { replace: true });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err?.message || 'Anmeldung fehlgeschlagen.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-slate-100 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src={logo} alt="medifin" className="h-auto w-[180px]" />
          <h1 className="mt-4 text-center font-semibold" style={{ fontSize: '18px', color: '#9B1F9B' }}>
            medifin GmbH CRM
          </h1>
          <p className="mt-2 text-sm text-slate-600">Bitte melde dich an, um fortzufahren.</p>
        </div>

        <form onSubmit={handleSubmit} className="card space-y-5">
          {hinweis && !error && (
            <div className="rounded-md bg-amber-50 p-3 text-sm text-amber-800 ring-1 ring-amber-200">
              {hinweis}
            </div>
          )}

          <div>
            <label htmlFor="email" className="label">
              E-Mail
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input mt-1"
            />
          </div>

          <div>
            <label htmlFor="password" className="label">
              Passwort
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input mt-1"
            />
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-3 text-sm text-red-700 ring-1 ring-red-200">
              {error}
            </div>
          )}

          <button type="submit" className="btn-primary w-full" disabled={submitting}>
            {submitting ? 'Anmelden …' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
